const learnLibrariesNavActiveState = {
    init: function(){
    	if(document.querySelector('#nav-interstitial')) {
	        document.getElementsByClassName('currentPage')[0].classList.remove('currentPage');
	    }
    },
};

export default learnLibrariesNavActiveState;